module.exports = __webpack_public_path__ + "img/0info.f764e16c.svg";